import React from "react";

import Head from "next/head";
import { theme } from "~styles/theme/main/theme";

import Layout from "@/components/layouts/layout/Layout";
import { FAQContentSection } from "@/components/sections/faq/FAQContentSection";

export const FAQPage = (): JSX.Element => {
  return (
    <Layout>
      <Head>
        <meta name="theme-color" content={theme.palette.primary.main} />
      </Head>
      <FAQContentSection />
    </Layout>
  );
};
